var React = require('react');

function SuccessActivity (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .success-activity-svg {\n        fill: #c7c7c7;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"className":"success-activity-svg","d":"M1349.98,498.13a0.454,0.454,0,0,0-.64,0l-5.68,5.7a0.454,0.454,0,0,1-.64,0l-1.4-1.4a0.452,0.452,0,0,0-.64,0l-0.85.861a0.45,0.45,0,0,0,0,.643l2.89,2.907a0.452,0.452,0,0,0,.64,0l7.18-7.2a0.45,0.45,0,0,0,0-.643Z","transform":"translate(-1340 -498.031)","key":1})]);
}

SuccessActivity.defaultProps = {"width":"11","height":"8.969","viewBox":"0 0 11 8.969"};

module.exports = SuccessActivity;

SuccessActivity.default = SuccessActivity;
